// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CKNe","index":"styles_index__2eyKm"};